module.exports = __webpack_public_path__ + "static/media/os_data.be307596.png";